import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "form1" }
const _hoisted_2 = { class: "panel" }
const _hoisted_3 = { class: "panel_left" }
const _hoisted_4 = { class: "image-slot" }
const _hoisted_5 = { class: "panel_right" }
const _hoisted_6 = { class: "example" }
const _hoisted_7 = ["src"]
const _hoisted_8 = { style: {"white-space":"pre-wrap"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_icon_picture = _resolveComponent("icon-picture")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_image = _resolveComponent("el-image")!
  const _component_Plus = _resolveComponent("Plus")!
  const _component_el_upload = _resolveComponent("el-upload")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _cache[5] || (_cache[5] = _createElementVNode("div", { class: "zhanwei4" }, null, -1)),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", null, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_el_form, {
              model: _ctx.form,
              "label-width": "auto",
              style: {"max-width":"600px"},
              "label-position": "top",
              ref: "ruleForm",
              "status-icon": ""
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_form_item, { label: "标题" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      modelValue: _ctx.form.startTitle,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.startTitle) = $event)),
                      size: "large"
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, { label: "内容" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      modelValue: _ctx.form.startContent,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.startContent) = $event)),
                      type: "textarea",
                      size: "large",
                      rows: "10",
                      maxlength: "500",
                      "show-word-limit": ""
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, { label: "图片" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_upload, {
                      class: "avatar-uploader",
                      action: _ctx.UpdateApi,
                      "show-file-list": false,
                      "on-success": _ctx.handleAvatarSuccess,
                      "before-upload": _ctx.beforeAvatarUpload,
                      "file-list": _ctx.fileList,
                      disabled: _ctx.allowUpload
                    }, {
                      default: _withCtx(() => [
                        (_ctx.form.startImg)
                          ? (_openBlock(), _createBlock(_component_el_image, {
                              key: 0,
                              src: _ctx.form.startImg,
                              class: "avatar",
                              alt: "",
                              fit: 'contain'
                            }, {
                              error: _withCtx(() => [
                                _createElementVNode("div", _hoisted_4, [
                                  _createVNode(_component_el_icon, null, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_icon_picture)
                                    ]),
                                    _: 1
                                  })
                                ])
                              ]),
                              _: 1
                            }, 8, ["src"]))
                          : (_openBlock(), _createBlock(_component_el_icon, {
                              key: 1,
                              class: "avatar-uploader-icon"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_Plus)
                              ]),
                              _: 1
                            }))
                      ]),
                      _: 1
                    }, 8, ["action", "on-success", "before-upload", "file-list", "disabled"])
                  ]),
                  _: 1
                }),
                (_ctx.allowUpload)
                  ? (_openBlock(), _createBlock(_component_el_form_item, { key: 0 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_button, {
                          type: "warning",
                          onClick: _ctx.clearImage
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t("settings.clearImg")), 1)
                          ]),
                          _: 1
                        }, 8, ["onClick"])
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                _createVNode(_component_el_form_item, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_button, {
                      type: "success",
                      size: "large",
                      style: {"background":"#4f4f4f","color":"#fff"},
                      onClick: _ctx.handleSave
                    }, {
                      default: _withCtx(() => _cache[2] || (_cache[2] = [
                        _createTextVNode("保存")
                      ])),
                      _: 1
                    }, 8, ["onClick"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["model"])
          ]),
          _createElementVNode("div", _hoisted_5, [
            _cache[4] || (_cache[4] = _createElementVNode("p", { class: "title" }, "App示意图", -1)),
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("img", {
                src: _ctx.form.startImg,
                alt: ""
              }, null, 8, _hoisted_7),
              _createElementVNode("p", null, _toDisplayString(_ctx.form.startTitle), 1),
              _createElementVNode("p", _hoisted_8, _toDisplayString(_ctx.form.startContent), 1),
              _cache[3] || (_cache[3] = _createElementVNode("p", null, [
                _createElementVNode("span", null, "继续")
              ], -1))
            ])
          ])
        ])
      ])
    ])
  ], 64))
}